
import {Component, Vue, Watch} from "vue-property-decorator";
import FlashMessage from "@/components/FlashMessage.vue";
import Toolbar from "@/components/Toolbar.vue";
import {store} from "@/Store";
import {api} from "./api/setup";


@Component({
    components: {

        FlashMessage,
        Toolbar,
    },
})
export default class App extends Vue {
    data = store.data;

    get background() {
        const fallback = '/img/android-chrome-192x192.004812bb.png';
        const song = this.data.currentSong;
        if (song && song.artist)
            return api(song.artist.image)
        return fallback;
    }
}
